import { motion } from "framer-motion";
import { STEPS } from "@/lib/data";
import { fadeUp, stagger, viewport } from "@/lib/motion";

export default function HowItWorks() {
  return (
    <section id="nasil" data-testid="how-section" className="py-24 md:py-32 bg-[#141178] text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-16">
          <span className="text-sm uppercase tracking-[0.2em] text-[#FFE500] font-semibold">04 · Nasıl İşliyor?</span>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight mt-4 leading-tight">
            {"Dört adımda Kazakistan'a."}
          </h2>
        </div>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={viewport}
          className="relative grid md:grid-cols-4 gap-8 md:gap-6"
        >
          <div className="hidden md:block absolute top-7 left-0 right-0 h-px bg-white/15" />
          {STEPS.map((s, i) => (
            <motion.div key={s.n} variants={fadeUp} custom={i} className="relative md:pl-0 pl-6 border-l md:border-l-0 border-white/15">
              <div className="relative z-10 grid place-items-center w-14 h-14 rounded-2xl bg-[#FFE500] text-[#1a1a1a] font-display text-xl font-bold mb-5 -ml-6 md:ml-0">
                {s.n}
              </div>
              <h3 className="font-display text-xl font-bold mb-2">{s.title}</h3>
              <p className="text-white/65 leading-relaxed text-sm">{s.text}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
